import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { Hero } from '../../components/Hero';
import { FiltersTabsContainer } from '../FiltersTabsContainer';
import { FiltersContainer } from '../FiltersContainer';
import { useSearchStringRedesignEnabled } from '../../hooks/useSearchStringRedesignEnabled';
import { SearchStringBlockContainer } from '../SearchStringBlockContainer/SearchStringBlockContainer';

export const HeroContainer: React.FC = () => {
  const title = useSelector((state: IApplicationState) => state.mainpage.seoData.h1);
  const isChildrenDayEnabled = useSelector((state: IApplicationState) => state.features.isChildrenDayEnabled);

  const isRedesignEnabled = useSearchStringRedesignEnabled();

  const filtersBlock = isRedesignEnabled.isEnabled ? (
    <SearchStringBlockContainer />
  ) : (
    <>
      <FiltersTabsContainer />
      <FiltersContainer />
    </>
  );

  return (
    <Hero
      title={title}
      isDobroshriftEnabled={false}
      isChildrenDayEnabled={isChildrenDayEnabled}
      filtersBlock={filtersBlock}
      isRedesignEnabled={isRedesignEnabled.isEnabled}
      searchStringExperimentGroup={isRedesignEnabled.experimentGroup}
    />
  );
};
